module.exports = {
  /* Customer text used in anchor subtitle */
  colorCrimsonLighter: "rgb(252, 233, 235)",
  colorCrimsonLight: "rgb(244, 168, 177)",
  colorCrimson: "rgb(234, 81, 100)",
  colorCrimsonDark: "rgb(187, 64, 80)",
  colorCrimsonDarker: "rgb(116, 40, 49)",
  colorInkLighter: "rgb(161, 169, 179)",
  colorInkLight: "rgb(129, 134, 143)",
  colorInk: "rgb(66, 69, 77)",
  colorInkDark: "rgb(20, 21, 26)",
  colorUiWhite: "rgb(255, 255, 255)",
  colorUiLight: "rgb(249, 250, 251)",
  colorUi: "rgb(241, 242, 245)",
  colorUiDark: "rgb(232, 234, 239)",
  colorUiDarker: "rgb(206, 210, 217)",
  colorChromiumLighter: "rgb(231, 240, 251)",
  colorChromiumLight: "rgb(162, 196, 237)",
  colorChromium: "rgb(69, 137, 220)",
  colorChromiumDark: "rgb(55, 109, 176)",
  colorChromiumDarker: "rgb(34, 68, 109)",
  colorUraniumLighter: "rgb(231, 247, 241)",
  colorUraniumLight: "rgb(162, 225, 199)",
  colorUranium: "rgb(70, 196, 144)",
  colorUraniumDark: "rgb(56, 156, 115)",
  colorUraniumDarker: "rgb(34, 97, 71)",
  colorSodiumLighter: "rgb(255, 247, 236)",
  colorSodiumLight: "rgb(255, 224, 180)",
  colorSodium: "rgb(255, 194, 106)",
  colorSodiumDark: "rgb(204, 155, 84)",
  colorSodiumDarker: "rgb(127, 96, 52)",
  colorLithiumLighter: "rgb(255, 237, 236)",
  colorLithiumLight: "rgb(255, 186, 182)",
  colorLithium: "rgb(255, 118, 109)",
  colorLithiumDark: "rgb(204, 94, 87)",
  colorLithiumDarker: "rgb(127, 58, 54)",
  /* Background color primary */
  colorBackgroundPrimary: "rgb(234, 81, 100)",
  /* Focus background color primary */
  colorBackgroundPrimaryFocus: "rgb(187, 64, 80)",
  /* Disabled background color primary */
  colorBackgroundPrimaryDisabled: "rgb(244, 168, 177)",
  /* Background color secondary */
  colorBackgroundSecondary: "rgb(241, 242, 245)",
  /* Focus background color secondary */
  colorBackgroundSecondaryFocus: "rgb(206, 210, 217)",
  /* Disabled background color secondary */
  colorBackgroundSecondaryDisabled: "rgb(249, 250, 251)",
  /* Background color prime */
  colorBackgroundPrime: "rgb(255, 194, 106)",
  /* Focus background color prime */
  colorBackgroundPrimeFocus: "rgb(204, 155, 84)",
  /* Disabled background color prime */
  colorBackgroundPrimeDisabled: "rgb(255, 224, 180)",
  /* Our product brand */
  colorBackgroundBrand: "rgb(234, 81, 100)",
  /* background color for success background */
  colorBackgroundSuccess: "rgb(162, 225, 199)",
  /* background color for warning background */
  colorBackgroundWarning: "rgb(255, 224, 180)",
  /* background color for critical background */
  colorBackgroundCritical: "rgb(255, 186, 182)",
  /* Border color base, input text normal */
  colorBorderBase: "rgb(206, 210, 217)",
  /* Border color focus, input text focus */
  colorBorderFocus: "rgb(69, 137, 220)",
  /* Border color critical, input text error */
  colorBorderCritical: "rgb(255, 118, 109)",
  /* Border input elements, buttons */
  borderRadiusBase: "4px",
  /* Border tooltip */
  borderRadiusMedium: "6px",
  borderRadiusLarge: "8px",
  borderRadiusXLarge: "16px",
  /* Border circle for global use */
  borderRadiusCircle: "100%",
  borderSizeThin: "1px",
  borderSizeThick: "2px",
  boxShadow0: "none",
  boxShadow1: "0 0 2px 0 rgba(0, 0, 0, 0.1), 0 2px 4px 0 rgba(0, 0, 0, 0.1)",
  easeOut: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
  easeOutSharp: "cubic-bezier(0.165, 0.84, 0.44, 1)",
  easeOutBounce: "cubic-bezier(.87,-.41,.19,1.44)",
  easeIn: "cubic-bezier(0.55, 0.085, 0.68, 0.53)",
  easeInSharp: "cubic-bezier(0.895, 0.03, 0.685, 0.22)",
  /* Font size H1 / Heading XLarge */
  fontSize27: "27px",
  /* Font size H2 / Heading Large */
  fontSize24: "24px",
  /* Font size H3 / Heading Regular */
  fontSize18: "18px",
  /* Font size H4 / Heading XLarge */
  fontSize16: "16px",
  /* Font size body text */
  fontSize14: "14px",
  /* Font size caption */
  fontSize12: "12px",
  /* Font size small text */
  fontSize10: "10px",
  fontFamilyPrimary: "-apple-system, 'BlinkMacSystemFont', 'San Francisco', 'Roboto', 'Segoe UI', 'Helvetica Neue', sans-serif",
  fontFamilyCode: "inconsolata, monospace",
  fontWeightRegular: "400",
  fontWeightMedium: "500",
  fontWeightSemiBold: "600",
  fontWeightBold: "700",
  letterSpacingXLarge: "0.1em",
  letterSpacingLarge: "0.05em",
  letterSpacingBase: "0",
  letterSpacingSmall: "-0.01em",
  letterSpacingXSmall: "-0.015em",
  lineHeightXLarge: "2",
  lineHeightLarge: "1.8",
  lineHeightBase: "1.5",
  lineHeightSmall: "1.3",
  lineHeightSmaller: "1",
  mediaQueryXSmall: "(min-width: 480px)",
  mediaQuerySmall: "(min-width: 600px)",
  mediaQueryMedium: "(min-width: 768px)",
  mediaQueryLarge: "(min-width: 1024px)",
  mediaQueryXLarge: "(min-width: 1200px)",
  opacitySoft: "0.65",
  opacityDisabled: "0.5",
  sizeHeightBase: "42px",
  sizeHeightLarge: "50px",
  sizeHeightXlarge: "60px",
  spaceXxLarge: "64px",
  spaceXLarge: "48px",
  spaceLarge: "32px",
  spaceBase: "24px",
  spaceSmall: "16px",
  spaceXSmall: "8px",
  spaceXxSmall: "4px",
  spaceNone: "0px",
  /* Text color primary */
  colorTextPrimary: "rgb(234, 81, 100)",
  /* Focus text color primary */
  colorTextPrimaryFocus: "rgb(187, 64, 80)",
  /* Disabled text color primary */
  colorTextPrimaryDisabled: "rgb(244, 168, 177)",
  /* Text color inverse for dark backgrounds */
  colorTextInverse: "rgb(255, 255, 255)",
  /* Focus text color inverse for dark backgrounds */
  colorTextInverseFocus: "rgba(255, 255, 255, 0.6)",
  /* Disabled text color inverse for dark backgrounds */
  colorTextInverseDisabled: "rgba(255, 255, 255, 0.4)",
  /* Text color secondary */
  colorTextSecondary: "rgb(66, 69, 77)",
  /* Focus text color secondary */
  colorTextSecondaryFocus: "rgba(66, 69, 77, 0.8)",
  /* Disabled text color secondary */
  colorTextSecondaryDisabled: "rgba(66, 69, 77, 0.4)",
  /* Link text primary */
  colorTextLinkPrimary: "rgb(234, 81, 100)",
  /* Disabled link text primary */
  colorTextLinkPrimaryDisabled: "rgb(244, 168, 177)",
  /* Focus link text primary */
  colorTextLinkPrimaryFocus: "rgb(187, 64, 80)",
  /* Link text secondary */
  colorTextLinkSecondary: "rgb(66, 69, 77)",
  /* Disabled link text secondary */
  colorTextLinkSecondaryDisabled: "rgb(161, 169, 179)",
  /* Focus link text secondary */
  colorTextLinkSecondaryFocus: "rgb(20, 21, 26)",
  /* Our product brand */
  colorTextBrand: "rgb(234, 81, 100)",
  /* Body text color */
  colorTextBody: "rgb(66, 69, 77)",
  /* Header text color. */
  colorTextHeader: "rgb(20, 21, 26)",
  /* Text color - subdued state */
  colorTextSubdued: "rgb(129, 134, 143)",
  /* Input placeholder text */
  colorTextPlaceholder: "rgb(161, 169, 179)",
  /* Text color for success text */
  colorTextSuccess: "rgb(34, 97, 71)",
  /* Text color for warning text */
  colorTextWarning: "rgb(127, 96, 52)",
  /* Text color for critical text */
  colorTextCritical: "rgb(127, 58, 54)",
  durationShort: "0.08s",
  durationBase: "0.5s",
  durationLong: "0.75s",
  durationXLong: "1s",
  durationXxLong: "2s",
  zIndexModal: "9999",
  zIndexDropdown: "8888",
  zIndexSticky: "100",
};